import { gql } from "@apollo/client";

export default gql`
  mutation SetGroupAwards($groupId: ObjectId!, $awards: [ObjectId!]!) {
    setGroupAwards(groupId: $groupId, awards: $awards) {
      _id
      awards {
        _id
        name
      }
    }
  }
`;
